import type {ReactElement} from 'react';
import { useState} from 'react';
import {Text, TextSize} from '@Components/text';
import {ForgotPasswordForm} from '@Components/forgot-password-form';
import styles from './connect-account-reset-password-form.module.scss';

export function ConnectAccountResetPasswordForm(): ReactElement<any> {
  const [showEmailPrompt, setShowEmailPrompt] = useState(true);

  const onForgotPasswordSubmit = (): void => {
    setShowEmailPrompt(false);
  };

  return (
    <div className={styles.resetPasswordStep}>
      {showEmailPrompt ? (
        <div className={styles.prompt}>
          <Text val={window.i18next.t('pmwjs_enter_email_to_reset_password')} size={TextSize.SMALL} className={styles.promptText} />
        </div>
      ) : null}
      <ForgotPasswordForm onSubmitCallback={onForgotPasswordSubmit} showSmallButton />
    </div>
  );
}
